import { DATA_VERSION } from '@space-core/datahub'
import useMembership from '@space-shell/common/hooks/useMembership'
import { useAuthStore, useUserInfoStore } from '@space-shell/core/store'
import { lazyRemoteModule } from '@space-shell/lib/runtime'

import type { SendDataHubConsumeProps } from './types'

const useSendDataHubConsume = () => {
  const { membershipData } = useMembership()
  const { id, userName, ucode } = useAuthStore()
  const { role } = useUserInfoStore()

  const sendDataHubConsume = async ({
    entity,
    action,
    event,
    dataVersion = DATA_VERSION
  }: SendDataHubConsumeProps) => {
    const remoteModule = await lazyRemoteModule<
      () => { dispatchDatahubCommunity: (args: object) => void }
    >('community/useDispatchDatahubCommunity')

    remoteModule?.().dispatchDatahubCommunity?.({
      action,
      entity,
      dataVersion,
      membershipData: {
        membershipName: membershipData?.name,
        membershipSlug: membershipData?.slug
      },
      userData: {
        userName: userName,
        userRole: role,
        ucode: ucode,
        marketplaceId: Number(id)
      },
      appVersion: process.env.PROJECT_VERSION,
      event
    })
  }

  return { sendDataHubConsume }
}

export default useSendDataHubConsume
